import React from 'react'
import { Heading, Box } from '@chakra-ui/react'
import { useDeviceType } from 'app/hooks'
import { useSelector } from 'react-redux'

const GeneralExamination = () => {
  const { isMobile } = useDeviceType()
  const { journeyType } = useSelector((state: any) => state.user)
  return (
    <Box px={isMobile ? 6 : 10} py={isMobile ? '4' : '5'}>
      <Heading size='20px'>
        {journeyType === 'LIFE' ? 'Life' : 'General'} Insurance Examination
      </Heading>
    </Box>
  )
}

export default GeneralExamination
